import { gql } from '@apollo/client'

export default gql(`
    mutation deletePublishingGroup($id: ID! $project: String) {
        deletePublishingGroup(
            input: {
                id: $id
            }
            project: $project
        ) {
            id
            status
        }
    }`
)
